import { useQuery, type UseQueryResult } from '@tanstack/react-query'

import * as dealsAPI from '../../../apis/dealsAPI'
import type { ShipmentEntity } from '../../../apis/dealsAPI'

export const SHIPMENTS_QUERY_KEY_ROOT = ['deals', 'shipments'] as const

export function shipmentsQueryKey(dealId: string): readonly unknown[] {
  return [...SHIPMENTS_QUERY_KEY_ROOT, 'list', dealId]
}

export function useShipmentsQuery(
  dealId: string | null,
  initialData?: ShipmentEntity[],
): UseQueryResult<ShipmentEntity[]> {
  return useQuery<ShipmentEntity[]>(
    shipmentsQueryKey(dealId ?? ''),
    () => dealsAPI.listShipments(dealId as string),
    {
      enabled: dealId !== null && dealId !== '',
      initialData,
      keepPreviousData: true,
    },
  )
}
